import { render, staticRenderFns } from "./TimeBasic.vue?vue&type=template&id=4c5d12de&"
import script from "./TimeBasic.vue?vue&type=script&lang=js&"
export * from "./TimeBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports